import {createSelector} from 'reselect'
import R from 'ramda'

import currentSortOption from './currentSortOption'

const comparator = (aa, bb) => aa < bb ? -1 : aa > bb ? 1 : 0;
const comp = (fieldName, asc) => (a, b) => {
  if(a.ignoreSort) {
    return -1
  } else if (b.ignoreSort) {
    return 1
  }
  const aa = a[fieldName]
  const bb = b[fieldName]
  return asc ? comparator(aa, bb) : comparator(bb, aa)
}

export default createSelector(
    
  [
    currentSortOption,
    (state) => state.estateList,
  ],
  (sortOption, estateList) => R.sort(comp(sortOption.fieldName, sortOption.asc), estateList)
  
)




/** WEBPACK FOOTER **
 ** ./app/selectors/sortedEstateList.js
 **/